export function rgbToString(rgb: number[], opacity = 1) {
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
}
